import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import {
  IPropertyFormDraft,
  PropertyFormDraftState
} from '@stores/PropertyFormDraft/types';
import { IAuthenticatedPropertyDetails } from '@stores/Property/types';

const FORM_DRAFT_SCHEMA_VERSION = 1;

const sanitizeFormData = (
  formData: IAuthenticatedPropertyDetails
): IAuthenticatedPropertyDetails => ({
  ...formData,
  fotos_galeria: (formData.fotos_galeria || [])
    .filter((photo) => !photo.file)
    .map((photo) => {
      const nextPhoto = { ...photo };
      delete nextPhoto.file;
      return nextPhoto;
    })
});

export const usePropertyFormDraftStore = create<PropertyFormDraftState>()(
  devtools(
    persist(
      (set, get) => ({
        drafts: {},

        upsertDraft: (
          key: string,
          formData: IAuthenticatedPropertyDetails,
          porcentagemComissaoDisplay: string
        ) => {
          const draft: IPropertyFormDraft = {
            version: FORM_DRAFT_SCHEMA_VERSION,
            updatedAt: new Date().toISOString(),
            formData: sanitizeFormData(formData),
            porcentagemComissaoDisplay
          };

          set((state) => ({
            drafts: {
              ...state.drafts,
              [key]: draft
            }
          }));
        },

        getDraft: (key: string) => {
          const draft = get().drafts[key];
          return draft ?? null;
        },

        clearDraft: (key: string) => {
          set((state) => {
            const nextDrafts = { ...state.drafts };
            delete nextDrafts[key];
            return { drafts: nextDrafts };
          });
        }
      }),
      {
        name: 'property-form-draft-store',
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({
          drafts: state.drafts
        })
      }
    )
  )
);
